import Vue from 'vue'

// export default {
//     install(Vue){ 
//         Vue.config.globalProperties.$numFormat = function(value){
//             try{
//                 return Number(value).toLocaleString();
//             }catch{
//                 return 0;
//             }
//         };

//         Vue.config.globalProperties.$dateFormat = function(nonFmtStr){
//             try{
//                 const date = new Date();
//                 const yy = date.getFullYear().toString() === nonFmtStr.substr(0,4) ? "" :nonFmtStr.substr(2,2)+".";
//                 // const yy = nonFmtStr.substr(2,2);
//                 const mm = nonFmtStr.substr(4,2);
//                 const dd = nonFmtStr.substr(6,2);
//                 return `${yy}${mm}.${dd}`
//             }catch{
//                 return nonFmtStr;
//             }
//         };
//     }
// }

// const methods = {
//     numFormat :(value) => {
//         try{
//             return Number(value).toLocaleString();
//         }catch{
//             return 0;
//         }
//     },
//     dateFormat : (nonFmtStr) => {
//         try{
//             const date = new Date();
//             const yy = date.getFullYear().toString() === nonFmtStr.substr(0,4) ? "" :nonFmtStr.substr(2,2)+".";
//             // const yy = nonFmtStr.substr(2,2);
//             const mm = nonFmtStr.substr(4,2);
//             const dd = nonFmtStr.substr(6,2);
//             return `${yy}${mm}.${dd}`
//         }catch{
//             return nonFmtStr;
//         }
//     }
// }

// export default {
//     install(Vue){ 
//         Vue.prototype.$numFormat = methods.numFormat
//         Vue.prototype.$dateFormat = methods.dateFormat
//     }
// }


export const numFormat = function(value){
    try{
        return Number(value).toLocaleString();
    }catch{
        return 0;
    }
}